/**
 * Pre-launch Mode JavaScript
 * Handles email signup forms for pre-launch mode
 */
(function() {
  'use strict';

  var API_URL = 'https://aiforthewtt-zazzy-dashboard.vercel.app/api/prelaunch/subscribe';
  var DISCOUNT_CODE = 'EARLYSIP15';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var forms = document.querySelectorAll('.prelaunch-form');
    console.log('[Prelaunch] Found ' + forms.length + ' forms');
    forms.forEach(attachFormHandler);

    if (sessionStorage.getItem('prelaunch-bar-closed')) {
      var bar = document.getElementById('prelaunch-bar');
      if (bar) bar.style.display = 'none';
    }

    // Also watch for dynamically added forms (Shopify sections)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var newForms = node.querySelectorAll ? node.querySelectorAll('.prelaunch-form') : [];
            newForms.forEach(function(form) {
              if (!form.dataset.prelaunchAttached) {
                form.dataset.prelaunchAttached = 'true';
                attachFormHandler(form);
                console.log('[Prelaunch] Attached handler to dynamic form');
              }
            });
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function attachFormHandler(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      handleSubmit(form);
    });
  }

  function handleSubmit(form) {
    var submitBtn = form.querySelector('.prelaunch-submit');
    var emailInput = form.querySelector('input[type="email"]');
    var honeypot = form.querySelector('input[name="website"]');

    if (honeypot && honeypot.value) {
      console.log('Bot detected');
      return;
    }

    if (!emailInput || !emailInput.value) {
      showError(form, 'Please enter your email address');
      return;
    }

    var originalText = submitBtn.textContent;
    submitBtn.textContent = 'Joining...';
    submitBtn.disabled = true;

    var container = form.closest('.prelaunch-notify-form') || form;
    var productId = container.dataset.productId || null;
    var productHandle = container.dataset.productHandle || null;
    var productTitle = container.dataset.productTitle || null;
    var sourceInput = form.querySelector('input[name="source"]');
    var source = sourceInput ? sourceInput.value : 'product_page';

    var urlParams = new URLSearchParams(window.location.search);

    var data = {
      email: emailInput.value.trim(),
      productId: productId,
      productHandle: productHandle,
      productTitle: productTitle,
      source: source,
      pageUrl: window.location.href,
      utmSource: urlParams.get('utm_source') || null,
      utmMedium: urlParams.get('utm_medium') || null,
      utmCampaign: urlParams.get('utm_campaign') || null
    };

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(function(response) { return response.json(); })
    .then(function(result) {
      console.log('[Prelaunch] API response:', result);
      if (result.success) {
        console.log('[Prelaunch] Showing success modal');
        showSuccessModal(result.discountCode || DISCOUNT_CODE, result.isNewSubscriber);
        form.reset();
      } else {
        showError(form, result.error || 'Something went wrong. Please try again.');
      }
    })
    .catch(function(error) {
      console.error('Prelaunch signup error:', error);
      showError(form, 'Connection error. Please try again.');
    })
    .finally(function() {
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    });
  }

  function closeModal(modal) {
    if (modal) {
      modal.remove();
      document.body.style.overflow = '';
    }
  }

  function createModal(content) {
    var modal = document.createElement('div');
    modal.className = 'prelaunch-modal';

    var overlay = document.createElement('div');
    overlay.className = 'prelaunch-modal-overlay';
    overlay.addEventListener('click', function() { closeModal(modal); });

    var contentDiv = document.createElement('div');
    contentDiv.className = 'prelaunch-modal-content';
    contentDiv.innerHTML = content;

    var closeBtn = contentDiv.querySelector('.prelaunch-modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() { closeModal(modal); });
    }

    var copyBtn = contentDiv.querySelector('.prelaunch-copy-btn');
    if (copyBtn) {
      copyBtn.addEventListener('click', function() { copyCode(); });
    }

    modal.appendChild(overlay);
    modal.appendChild(contentDiv);
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') {
        closeModal(modal);
        document.removeEventListener('keydown', escHandler);
      }
    });

    return modal;
  }

  function showSuccessModal(discountCode, isNew) {
    var existing = document.querySelector('.prelaunch-modal');
    if (existing) existing.remove();

    var title = isNew ? "You're on the list!" : "You're already signed up!";
    var message = isNew
      ? "We'll email you the moment we launch. As a thank you, here's your exclusive discount:"
      : "Great news - you're already on our early access list! Here's your discount code again:";

    var content =
      '<button class="prelaunch-modal-close" aria-label="Close">&times;</button>' +
      '<div class="prelaunch-modal-icon">🎉</div>' +
      '<h2>' + title + '</h2>' +
      '<p>' + message + '</p>' +
      '<div class="prelaunch-discount-box">' +
        '<span class="prelaunch-discount-code" id="discount-code">' + discountCode + '</span>' +
        '<button class="prelaunch-copy-btn">Copy</button>' +
      '</div>' +
      '<p class="prelaunch-modal-note">Save this code - 15% off your first order when we launch!</p>';

    createModal(content);
  }

  function showError(form, message) {
    var errorEl = form.querySelector('.prelaunch-error');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'prelaunch-error';
      form.appendChild(errorEl);
    }
    errorEl.textContent = message;
    setTimeout(function() { if (errorEl.parentNode) errorEl.remove(); }, 5000);
  }

  function copyCode() {
    var code = document.getElementById('discount-code');
    if (code) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code.textContent);
      } else {
        var textarea = document.createElement('textarea');
        textarea.value = code.textContent;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      var btn = document.querySelector('.prelaunch-copy-btn');
      if (btn) {
        btn.textContent = 'Copied!';
        setTimeout(function() { btn.textContent = 'Copy'; }, 2000);
      }
    }
  }

  window.closePrelaunchBar = function() {
    var bar = document.getElementById('prelaunch-bar');
    if (bar) {
      bar.style.display = 'none';
      sessionStorage.setItem('prelaunch-bar-closed', 'true');
    }
  };

  window.openPrelaunchModal = function() {
    var existing = document.querySelector('.prelaunch-modal');
    if (existing) existing.remove();

    var content =
      '<button class="prelaunch-modal-close" aria-label="Close">&times;</button>' +
      '<h2>Get Early Access</h2>' +
      '<p>Be the first to shop our THC beverages + get 15% off your first order.</p>' +
      '<form class="prelaunch-form">' +
        '<input type="email" name="email" placeholder="Enter your email" required class="prelaunch-input">' +
        '<input type="hidden" name="source" value="announcement_bar">' +
        '<input type="text" name="website" style="display:none" tabindex="-1" autocomplete="off">' +
        '<button type="submit" class="prelaunch-submit">Join Early Access</button>' +
      '</form>' +
      '<p class="prelaunch-privacy">No spam, ever. Unsubscribe anytime.</p>';

    var modal = createModal(content);
    attachFormHandler(modal.querySelector('.prelaunch-form'));
  };

  window.copyPrelaunchCode = function() { copyCode(); };

})();
